(function () {
    'use strict';
    a3_pilot_reports.factory('DebugFactory', DebugFactory);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name DebugFactory
    * @description 
    *    Authorize check from API ...
    * @ngInject
    */
    function DebugFactory(GenericService, $http, $q, apiUrl, LogService){
        /**
        * Initialize Debug
        * @memberof DebugFactory
        */
        var service = {
            CheckAuthorized: CheckAuthorized
        }
        function CheckAuthorized(value, callback){
            return $http.get(apiUrl + '/debug/CheckAuthorized/' + value, { 'Content-Type': 'application/json' })
            .then(callback);
    }

        return service;
    }
})();
